// Internal modules
import { appStore } from './store';

const ADDRESS_GROUP_REGEX = /^(billing|shipping)Address$/;

const dispatchFormAction = ({ addressType, field, isBatchUpdate, payload }) => {
  const { form: formActions } = appStore.getActions();
  const isAddressField = ADDRESS_GROUP_REGEX.test(addressType);
  const action = isAddressField
    ? 'updateAddressField'
    : 'updateNonAddressField';
  const data = {
    ...(isAddressField && { addressType, isBatchUpdate }),
    field,
    payload,
  };

  return formActions[action](data);
};

export { dispatchFormAction };
